import { Component, ElementRef, EventEmitter, HostListener, Input, OnChanges, OnDestroy, OnInit, Output, SimpleChanges, ViewChild } from '@angular/core';
import { CdkDragDrop, moveItemInArray } from '@angular/cdk/drag-drop';
import { HttpClient } from '@angular/common/http';
import { ActivatedRoute, Router } from '@angular/router';
import { Subscription } from 'rxjs';
import { DialogRef, DialogService } from '@progress/kendo-angular-dialog';
import { HistoricoProdutoComponent } from '../../historico-produto/historico-produto.component';
import { KendoPopupUtils } from '../../lib/KendoPopupUtils';
import { ConstantsService } from '../../fidelidade/ConstantsService';
import { RotaGuardClient } from '../../guards/auth-loja.guard';
import { AutorizacaoService } from '../../services/autorizacao.service';
import { NotificationService } from '../../services/notification.service';
import { ProdutosV2FacadeService } from '../produtos-v2.facade';
import {
  ChoiceGroupVM,
  ChoiceOptionVM,
  LibraryGroupVM,
  PizzaAdditionalVM,
  ProductEditorGroupDraftModeV2,
  ProductEditorSurfaceV2,
  ProductEditorVM,
  ProductTypeV2
} from '../produtos-v2.models';
import { TelaEditorAdicionalV2Component } from '../tela-editor-adicional-v2/tela-editor-adicional-v2.component';

type ProductEditorOptionModeV2 = 'review' | 'activation' | 'batch-price';
type ProductEditorOptionSortV2 = 'name-asc' | 'price-asc' | 'price-desc';
type BatchPriceAdjustMode = 'fixed' | 'increment' | 'percent';

@Component({
  selector: 'app-tela-editor-produto-v2',
  templateUrl: './tela-editor-produto-v2.component.html',
  styleUrls: ['./tela-editor-produto-v2.component.scss']
})
export class TelaEditorProdutoV2Component implements OnInit, OnChanges, OnDestroy {
  @ViewChild(TelaEditorAdicionalV2Component) adicionalEditorComponent?: TelaEditorAdicionalV2Component;
  readonly mobileDenseGroupThreshold = 10;
  @Input() embedded = false;
  @Input() productId: number | null = null;
  @Input() newProductType: ProductTypeV2 | null = null;
  @Input() startWithPreview = false;
  @Input() startWithLibrary = false;
  @Input() pizzaTemplateId: number | null = null;
  @Input() surfaceMode: ProductEditorSurfaceV2 = 'overview';
  @Input() focusGroupId: number | string | null = null;
  @Input() groupDraftMode: ProductEditorGroupDraftModeV2 | null = null;
  @Input() requestedOptionMode: ProductEditorOptionModeV2 | null = null;
  @Input() scrollToSection: string | null = null;
  @Output() closeRequested = new EventEmitter<void>();
  @Output() productResolved = new EventEmitter<number>();
  @Output() productPersisted = new EventEmitter<void>();
  @Output() surfaceChangeRequested = new EventEmitter<{
    surfaceMode: ProductEditorSurfaceV2;
    focusGroupId?: number | string | null;
    groupDraftMode?: ProductEditorGroupDraftModeV2 | null;
    startWithLibrary?: boolean;
    optionMode?: ProductEditorOptionModeV2 | null;
  }>();

  empresa: any;
  editor: ProductEditorVM | null = null;
  loading = true;
  isMobile = false;
  saveState = '';
  saveStateMuted = true;
  isNewProduct = false;
  showAdvanced = false;
  infoPanelOpen = false;
  previewOpen = false;
  libraryOpen = false;
  groupPanelOpen = false;
  sectionPromotionOpen = false;
  sectionAvailabilityOpen = false;
  sectionClassificationOpen = false;
  groupDraft: ChoiceGroupVM | null = null;
  editingGroupId: number | string | null = null;
  draftOptions: ChoiceOptionVM[] = [];
  draftOptionInput = '';
  groupPanelTitle = 'Novo adicional';
  librarySearch = '';
  libraryFilter = 'Todos';
  libraryLoading = false;
  libraryItems: LibraryGroupVM[] = [];
  availableTags: any[] = [];
  templates: any[] = [];
  expandedGroups: Record<string, boolean> = {};
  optionMode: ProductEditorOptionModeV2 = 'review';
  optionSearch = '';
  optionFilter: 'all' | 'active' | 'inactive' = 'all';
  optionSort: ProductEditorOptionSortV2 = 'name-asc';
  batchPriceInput = '';
  batchSelection: Record<string, boolean> = {};
  groupOptionModes: Record<string, ProductEditorOptionModeV2> = {};
  groupOptionSearchState: Record<string, string> = {};
  groupOptionFilterState: Record<string, 'all' | 'active' | 'inactive'> = {};
  groupOptionSortState: Record<string, ProductEditorOptionSortV2> = {};
  batchSheetOpen = false;
  batchAdjustMode: BatchPriceAdjustMode = 'fixed';
  batchAdjustValue = '';
  reorderSheetOpen = false;
  reorderList: ChoiceGroupVM[] = [];
  reorderDirty = false;
  reorderErrorMsg = '';
  reorderShaking = false;
  reorderApplying = false;
  editSheetOpen = false;
  editingOptionId: string | number | null = null;
  editingOptionName = '';
  editingOptionDescription = '';
  editingOptionPrice: number | null = null;
  editingOptionActive = true;
  groupFormCollapsedMobile = true;
  unidades: any[] = [];
  temModuloFidelidade = false;
  temModuloPedidos = false;
  temModuloFiscal = false;
  temModuloEstoque = false;
  sectionFiscalOpen = false;
  sectionFidelidadeOpen = false;
  sectionEstoqueOpen = false;
  sectionMassaOpen = false;
  sectionBordaOpen = false;
  dadosFiscais: { origens: any[]; tiposTributacaoIPI: any[]; selosControleIPI: any[] } | null = null;
  fiscalLoading = false;
  creationImagePreview: string | null = null;
  adicionalActionBarState: { creationPhase: 'config' | 'full'; saveFooterState: 'hidden' | 'dirty' | 'saving' | 'saved' } = {
    creationPhase: 'config',
    saveFooterState: 'hidden'
  };

  private infoTimer: any = null;
  private promotionTimer: any = null;
  private availabilityTimer: any = null;
  private classificationTimer: any = null;
  private fiscalTimer: any = null;
  private fidelidadeTimer: any = null;
  private groupTimers: Record<string, any> = {};
  private lastLoadSignature = '';
  private optionBrowserContextKey = '';
  private optionRuntimeKeys = new WeakMap<ChoiceOptionVM, string>();
  private optionRuntimeKeySequence = 0;
  private empresaSubscription?: Subscription;
  private moduloFidelidadeSubscription?: Subscription;
  private moduloPedidoSubscription?: Subscription;
  private moduloFiscalSubscription?: Subscription;
  private moduloEstoqueSubscription?: Subscription;
  private routeParamsSubscription?: Subscription;
  private routeQueryParamsSubscription?: Subscription;

  constructor(
    private constantsService: ConstantsService,
    private facade: ProdutosV2FacadeService,
    private activatedRoute: ActivatedRoute,
    private router: Router,
    private notificationService: NotificationService,
    private httpClient: HttpClient,
    private autorizacaoService: AutorizacaoService,
    private dialogService: DialogService,
    private elementRef: ElementRef
  ) {
    this.handleResize();
  }

  ngOnInit(): void {
    if (!this.embedded) {
      const productId = this.activatedRoute.snapshot.params['id'];
      const tipo = this.activatedRoute.snapshot.queryParams['tipo'];
      this.router.navigate(['/admin/fidelidade/produtos-v2'], {
        queryParams: productId
          ? { produtoDrawer: productId }
          : { novoTipoDrawer: tipo || 'normal' },
        replaceUrl: true
      });
      return;
    }

    this.empresaSubscription = this.constantsService.empresa$.subscribe(async (empresa) => {
      if (!empresa?.catalogo?.id) return;
      this.empresa = empresa;
      await this.syncContextLoad();
    });

    this.moduloFidelidadeSubscription = this.constantsService.moduloFidelidade$.subscribe((v) => this.temModuloFidelidade = !!v);
    this.moduloPedidoSubscription = this.constantsService.moduloPedido$.subscribe((v) => this.temModuloPedidos = !!v);
    this.moduloFiscalSubscription = this.constantsService.moduloFiscal$.subscribe((v) => this.temModuloFiscal = !!v);
    this.moduloEstoqueSubscription = this.constantsService.moduloEstoque$.subscribe((v) => this.temModuloEstoque = !!v);

    this.routeParamsSubscription = this.activatedRoute.params.subscribe(async () => {
      if (this.embedded || !this.empresa) return;
      await this.syncContextLoad();
    });

    this.routeQueryParamsSubscription = this.activatedRoute.queryParams.subscribe(async () => {
      if (this.embedded || !this.empresa) return;
      await this.syncContextLoad();
    });
  }

  async ngOnChanges(changes: SimpleChanges): Promise<void> {
    if (!this.embedded || !this.empresa) return;
    if (
      changes['productId']
      || changes['newProductType']
      || changes['startWithPreview']
      || changes['startWithLibrary']
      || changes['surfaceMode']
      || changes['focusGroupId']
      || changes['groupDraftMode']
      || changes['requestedOptionMode']
    ) {
      await this.syncContextLoad(true);
    }
  }

  ngOnDestroy(): void {
    this.empresaSubscription?.unsubscribe();
    this.moduloFidelidadeSubscription?.unsubscribe();
    this.moduloPedidoSubscription?.unsubscribe();
    this.moduloFiscalSubscription?.unsubscribe();
    this.moduloEstoqueSubscription?.unsubscribe();
    this.routeParamsSubscription?.unsubscribe();
    this.routeQueryParamsSubscription?.unsubscribe();
    if (this.infoTimer) clearTimeout(this.infoTimer);
    if (this.promotionTimer) clearTimeout(this.promotionTimer);
    if (this.availabilityTimer) clearTimeout(this.availabilityTimer);
    if (this.classificationTimer) clearTimeout(this.classificationTimer);
    if (this.fiscalTimer) clearTimeout(this.fiscalTimer);
    if (this.fidelidadeTimer) clearTimeout(this.fidelidadeTimer);
    Object.keys(this.groupTimers).forEach((key) => clearTimeout(this.groupTimers[key]));
  }

  @HostListener('window:resize')
  handleResize() {
    this.isMobile = window.innerWidth < 1024;
    if (!this.isMobile) {
      this.sectionPromotionOpen = true;
      this.sectionAvailabilityOpen = true;
      this.sectionClassificationOpen = true;
    }
  }

  get categorias(): any[] {
    return this.empresa?.catalogo?.categorias || [];
  }

  get catalogoCompartilhado(): boolean {
    return !!this.empresa?.catalogo?.compartilhado;
  }

  get precoPorEmpresa(): boolean {
    return !!this.empresa?.catalogo?.precoPorEmpresa;
  }

  get disponibilidadePorEmpresa(): boolean {
    return !!this.empresa?.catalogo?.disponibilidadePorEmpresa;
  }

  get podeEditarProdutos(): boolean {
    return !this.empresa?.id || !this.catalogoCompartilhado;
  }

  get podeEditarPrecos(): boolean {
    return this.podeEditarProdutos
      || (this.precoPorEmpresa && RotaGuardClient.alterarPrecoCardapioCompartilhado(this.autorizacaoService.getUser()));
  }

  get podeEditarEstruturaAdicional(): boolean {
    return this.podeEditarProdutos;
  }

  get podeEditarPrecoOpcoes(): boolean {
    return this.podeEditarPrecos;
  }

  get podeEditarDisponibilidadeOpcoes(): boolean {
    return this.podeEditarProdutos || this.disponibilidadePorEmpresa;
  }

  get podeEditarAlgumaOpcao(): boolean {
    return this.podeEditarEstruturaAdicional || this.podeEditarPrecoOpcoes || this.podeEditarDisponibilidadeOpcoes;
  }

  get vendidoPorPeso(): boolean {
    return this.editor?.tipoDeVenda === 'Peso';
  }

  get vendidoPorUnidade(): boolean {
    return !this.editor?.tipoDeVenda || this.editor?.tipoDeVenda === 'Unidade';
  }

  get hasAdvancedValues(): boolean {
    if (!this.editor) return false;
    return !!(
      this.editor.codigoPdv ||
      (this.editor.incremento != null && this.editor.incremento > 1) ||
      (this.editor.qtdeMinima != null && this.editor.qtdeMinima !== 1 && this.editor.qtdeMinima !== 0) ||
      (this.editor.qtdMaxima != null && this.editor.qtdMaxima > 0)
    );
  }

  obtenhaFormatoPrecoV2(): string {
    if (!this.editor?.tipoDeVenda || this.editor.tipoDeVenda !== 'Peso') {
      return '$0.00';
    }

    return '$ 0.00/ kg';
  }

  get showExibirNoSite(): boolean {
    return this.temModuloFidelidade && !this.temModuloPedidos;
  }

  get showNaoSincronizar(): boolean {
    return this.catalogoCompartilhado;
  }

  get pontuarFidelidade(): boolean {
    if (!this.empresa?.integracaoPedidoFidelidade) return false;
    const tipoAcumulo = this.empresa.integracaoPedidoFidelidade?.plano?.tipoDePontuacao?.tipo;
    return tipoAcumulo === 'qtde-variavel-por-atividade' || tipoAcumulo === 'cashback';
  }

  get acumulaReais(): boolean {
    if (!this.empresa?.integracaoPedidoFidelidade) return false;
    return this.empresa.integracaoPedidoFidelidade?.plano?.tipoDeAcumulo === 'Reais';
  }

  get filteredLibraryItems(): LibraryGroupVM[] {
    const term = this.librarySearch.trim().toLowerCase();
    return this.libraryItems.filter((item) => {
      const matchSearch = !term || item.name.toLowerCase().includes(term);
      if (this.libraryFilter === 'Mais usados') return matchSearch && item.sharedCount > 0;
      if (this.libraryFilter === 'Recentes') return matchSearch && item.sharedCount <= 3;
      return matchSearch;
    });
  }

  get activeSurfaceMode(): ProductEditorSurfaceV2 {
    if (this.embedded) {
      return this.surfaceMode || 'overview';
    }

    return (this.activatedRoute.snapshot.queryParams.drawerSurface
      || this.activatedRoute.snapshot.queryParams.surface
      || 'overview') as ProductEditorSurfaceV2;
  }

  get isOverviewSurface(): boolean {
    return this.activeSurfaceMode === 'overview';
  }

  get isGroupDetailSurface(): boolean {
    return this.activeSurfaceMode === 'group-detail';
  }

  get shouldShowInlineLibrary(): boolean {
    return this.libraryOpen && this.isGroupDetailSurface;
  }

  get focusedGroup(): ChoiceGroupVM | null {
    if (!this.editor) return null;
    const focusGroupId = this.getContextFocusGroupId();
    if (focusGroupId == null) return null;
    return this.editor.groups.find((grupo) => String(grupo.id) === String(focusGroupId)) || null;
  }

  get isCreatingGroupDetail(): boolean {
    return this.getContextGroupDraftMode() === 'create';
  }

  get isReviewMode(): boolean {
    return this.optionMode === 'review';
  }

  get isActivationMode(): boolean {
    return this.optionMode === 'activation';
  }

  get isBatchPriceMode(): boolean {
    return this.optionMode === 'batch-price';
  }

  get batchSelectedCount(): number {
    return Object.keys(this.batchSelection).filter((key) => this.batchSelection[key]).length;
  }

  get focusedGroupPricePresets(): number[] {
    const prices = new Set(
      (this.focusedGroup?.options || [])
        .map((option) => Number(option.price || 0))
        .filter((price) => Number.isFinite(price))
    );

    return Array.from(prices)
      .sort((a, b) => a - b)
      .slice(0, 6);
  }

  get filteredFocusedGroupOptions(): ChoiceOptionVM[] {
    const group = this.focusedGroup;
    if (!group) return [];

    const term = this.optionSearch.trim().toLowerCase();
    const filtered = (group.options || []).filter((option) => {
      const matchesSearch = !term || (option.name || '').toLowerCase().includes(term);
      if (!matchesSearch) return false;

      if (this.optionFilter === 'active') {
        return option.active !== false;
      }

      if (this.optionFilter === 'inactive') {
        return option.active === false;
      }

      return true;
    });

    return filtered.sort((left, right) => {
      if (this.optionSort === 'price-asc') {
        return Number(left.price || 0) - Number(right.price || 0)
          || String(left.name || '').localeCompare(String(right.name || ''), 'pt-BR');
      }

      if (this.optionSort === 'price-desc') {
        return Number(right.price || 0) - Number(left.price || 0)
          || String(left.name || '').localeCompare(String(right.name || ''), 'pt-BR');
      }

      return String(left.name || '').localeCompare(String(right.name || ''), 'pt-BR');
    });
  }

  async carregueTela() {
    this.loading = true;
    try {
      const [tags, templates, unidades] = await Promise.all([
        this.facade.carregueTags(),
        this.facade.carregueTemplates(this.empresa.catalogo),
        this.facade.carregueUnidades()
      ]);
      this.availableTags = tags || [];
      this.templates = templates || [];
      this.unidades = unidades || [];

      const id = this.getContextProductId();
      if (id) {
        this.editor = await this.facade.carregueProduto(this.empresa, Number(id), this.templates);
      } else {
        const tipo = this.getContextProductType();
        let templatesParaCriacao = this.templates;
        if (tipo === 'pizza' && this.pizzaTemplateId) {
          const templateEspecifico = this.templates.find((t: any) => t.id === this.pizzaTemplateId);
          if (templateEspecifico) {
            templatesParaCriacao = [templateEspecifico];
          }
        }
        this.editor = this.facade.mapEditor(this.facade.crieProdutoNovo(tipo, this.empresa.catalogo, templatesParaCriacao), this.templates);
      }

      this.isNewProduct = !id;
      this.showAdvanced = false;
      this.initializeExpandedGroups();
      this.infoPanelOpen = false;
      this.groupPanelOpen = false;
      this.libraryOpen = false;
      this.previewOpen = false;

      if (!this.isMobile) {
        this.sectionPromotionOpen = true;
        this.sectionAvailabilityOpen = true;
        this.sectionClassificationOpen = true;
      }

      this.previewOpen = this.shouldStartWithPreview();
      this.initializeGroupDetailDraft();
      if (this.shouldStartWithLibrary()) {
        await this.openLibrary();
      }
      if (this.scrollToSection === 'adicionais') {
        setTimeout(() => {
          const el = this.elementRef.nativeElement.querySelector('.pv2-groups-header');
          if (el) {
            const scrollParent = el.closest('.pv2-editor-drawer') || el.closest('.pv2-editor-page') || window;
            const rect = el.getBoundingClientRect();
            const offset = 100;
            if (scrollParent === window) {
              window.scrollBy({ top: rect.top - offset, behavior: 'smooth' });
            } else {
              (scrollParent as HTMLElement).scrollBy({ top: rect.top - (scrollParent as HTMLElement).getBoundingClientRect().top - offset, behavior: 'smooth' });
            }
          }
          this.scrollToSection = null;
        }, 150);
      }
    } finally {
      this.loading = false;
    }
  }

  async recarregueEditor(preservePanels = true) {
    if (!this.editor) return;

    const infoOpen = this.infoPanelOpen;
    const previewOpen = this.previewOpen;
    const libraryOpen = this.libraryOpen;
    const sectionPromotionOpen = this.sectionPromotionOpen;
    const sectionAvailabilityOpen = this.sectionAvailabilityOpen;
    const sectionClassificationOpen = this.sectionClassificationOpen;
    const currentExpanded = { ...this.expandedGroups };
    const previousImage = this.editor.image;

    let newEditor: ProductEditorVM;
    if (this.editor.id) {
      newEditor = await this.facade.carregueProduto(this.empresa, Number(this.editor.id), this.templates);
    } else {
      newEditor = this.facade.mapEditor(this.editor.raw, this.templates);
    }

    if (!newEditor.image && previousImage) {
      newEditor.image = previousImage;
    }
    this.editor = newEditor;

    this.expandedGroups = {};
    this.editor.groups.forEach((grupo) => {
      const key = this.groupKey(grupo);
      this.expandedGroups[key] = currentExpanded[key] !== false;
    });

    this.initializeGroupDetailDraft();

    if (preservePanels) {
      this.infoPanelOpen = infoOpen;
      this.previewOpen = previewOpen;
      this.libraryOpen = libraryOpen;
      this.sectionPromotionOpen = sectionPromotionOpen;
      this.sectionAvailabilityOpen = sectionAvailabilityOpen;
      this.sectionClassificationOpen = sectionClassificationOpen;
    }
  }

  onPizzaOptionChanged(adicional: PizzaAdditionalVM | null | undefined) {
    if (!this.podeEditarDisponibilidadeOpcoes) {
      this.notifySharedCatalogBlocked('A disponibilidade está bloqueada neste catálogo compartilhado.');
      return;
    }
    if (adicional) adicional.dirty = true;
  }

  async savePizzaAdicional(adicional: PizzaAdditionalVM | null | undefined) {
    if (!this.podeEditarAlgumaOpcao) {
      this.notifySharedCatalogBlocked();
      return;
    }
    if (!adicional || !this.editor || adicional.saving) return;
    try {
      await this.facade.salvePizzaAdicional(this.empresa.catalogo, this.editor.raw, adicional, this.empresa);
      this.notificationService.showSuccess(`${adicional.name}s salvas com sucesso!`);
    } catch (err) {
      this.notificationService.showError(`Erro ao salvar ${adicional.name.toLowerCase()}s.`);
    }
  }

  goBack() {
    if (this.embedded && this.isGroupDetailSurface) {
      this.requestSurfaceChange('overview');
      return;
    }

    if (this.embedded) {
      this.closeRequested.emit();
      return;
    }

    if (this.isGroupDetailSurface) {
      this.requestSurfaceChange('overview');
      return;
    }

    void this.navigateToAdminCatalog();
  }

  openInfoPanel() {
    if (this.isGroupDetailSurface) return;
    this.infoPanelOpen = true;
  }

  closeInfoPanel() {
    this.infoPanelOpen = false;
  }

  openHistorico() {
    if (!this.editor?.id) return;

    const windowRef: DialogRef = this.dialogService.open({
      title: 'Histórico do produto',
      content: HistoricoProdutoComponent,
      minWidth: 250,
      width: window.innerWidth > 900 ? 900 : window.innerWidth,
      maxHeight: window.innerHeight - 100,
      cssClass: 'bsModal'
    });

    KendoPopupUtils.abriuPopupNgBootstrap(windowRef);
    windowRef.content.instance.produto = { id: this.editor.id };
    windowRef.result.subscribe(() => {}, () => {});
  }

  openPreview() {
    if (this.isGroupDetailSurface) return;
    this.previewOpen = true;
  }

  closePreview() {
    this.previewOpen = false;
  }

  onEditorImageError() {
    if (!this.editor) return;

    const nextCandidateIndex = (this.editor.imageCandidateIndex ?? 0) + 1;
    const nextCandidate = this.editor.imageCandidates?.[nextCandidateIndex] || null;

    if (nextCandidate) {
      this.editor.imageCandidateIndex = nextCandidateIndex;
      this.editor.image = nextCandidate;
      return;
    }

    this.editor.image = null;
  }

  hasEditorImage(): boolean {
    return !!this.editor?.image;
  }

  getEditorPlaceholder(): string {
    if (!this.editor) return '🍽️';
    return this.editor.emoji || (this.editor.type === 'pizza' ? '🍕' : '🍽️');
  }

  async salveImagensProduto(fnRetorno: Function) {
    if (!this.podeEditarProdutos) {
      this.notifySharedCatalogBlocked('As imagens do produto estão bloqueadas neste catálogo compartilhado.');
      return;
    }
    try {
      await this.facade.salveImagensProduto(this.empresa, this.editor!.raw);
      await this.recarregueEditor(true);
      this.markSaved();
      fnRetorno();
    } catch (erro) {
      fnRetorno(erro);
    }
  }

  async openLibrary() {
    if (!this.podeEditarProdutos) {
      this.notifySharedCatalogBlocked('A biblioteca está bloqueada neste catálogo compartilhado.');
      return;
    }
    if (this.embedded && this.isOverviewSurface) {
      this.requestSurfaceChange('group-detail', null, 'create', true);
      return;
    }

    this.libraryLoading = true;
    this.libraryOpen = true;
    try {
      this.libraryItems = await this.facade.carregueBiblioteca(this.empresa.catalogo, this.librarySearch, this.editor?.raw || this.editor || null);
    } finally {
      this.libraryLoading = false;
    }
  }

  closeLibrary() {
    this.libraryOpen = false;
  }

  async openDedicatedEditor() {
    await this.promoteToDedicatedEditor(undefined, true);
  }

  async refreshLibrary() {
    this.libraryLoading = true;
    try {
      this.libraryItems = await this.facade.carregueBiblioteca(this.empresa.catalogo, this.librarySearch, this.editor?.raw || this.editor || null);
    } finally {
      this.libraryLoading = false;
    }
  }

  toggleGroup(grupo: ChoiceGroupVM) {
    const key = this.groupKey(grupo);
    this.expandedGroups[key] = !this.expandedGroups[key];
  }

  isExpanded(grupo: ChoiceGroupVM): boolean {
    return this.expandedGroups[this.groupKey(grupo)] !== false;
  }

  onGroupCardPressed(grupo: ChoiceGroupVM) {
    if (this.embedded && this.isOverviewSurface) {
      this.requestSurfaceChange('group-detail', grupo.id, 'edit');
      return;
    }

    if (this.shouldUseDenseGroupSummary(grupo)) {
      this.openGroupDetail(grupo);
      return;
    }

    this.toggleGroup(grupo);
  }

  async openGroupPanel(grupo?: ChoiceGroupVM) {
    if (!this.editor) return;

    if (grupo && !this.canEditGroupStructure(grupo)) {
      this.openGroupDetail(grupo);
      return;
    }

    if (grupo && this.isFixedGroup(grupo)) {
      this.openGroupDetail(grupo);
      return;
    }

    if (!this.embedded && grupo && this.shouldUseDenseGroupSummary(grupo)) {
      this.openGroupDetail(grupo);
      return;
    }

    if (!this.podeEditarEstruturaAdicional) {
      this.notifySharedCatalogBlocked('A estrutura do adicional está bloqueada neste catálogo compartilhado.');
      return;
    }

    if (this.embedded) {
      this.requestSurfaceChange('group-detail', grupo?.id ?? null, grupo ? 'edit' : 'create');
      return;
    }

    let targetGroup = grupo || null;
    if (grupo?.shared && grupo.kind === 'adicional') {
      targetGroup = await this.prepareSharedGroup(grupo);
      if (!targetGroup) return;
    }

    if (targetGroup) {
      this.groupPanelTitle = 'Editar adicional';
      this.editingGroupId = targetGroup.id;
      this.groupDraft = this.cloneGroup(targetGroup);
    } else {
      this.groupPanelTitle = 'Novo adicional';
      this.editingGroupId = null;
      this.groupDraft = this.buildEmptyGroupDraft();
    }

    this.groupPanelOpen = true;
  }

  closeGroupPanel() {
    this.groupPanelOpen = false;
    this.groupDraft = null;
    this.editingGroupId = null;
    this.draftOptions = [];
    this.draftOptionInput = '';
  }

  async saveGroupPanel() {
    if (!this.editor || !this.groupDraft) return;
    if (!this.podeEditarEstruturaAdicional) {
      this.notifySharedCatalogBlocked('A estrutura do adicional está bloqueada neste catálogo compartilhado.');
      return;
    }
    if (this.isFixedGroup(this.groupDraft)) {
      this.notificationService.showError('Os tamanhos da pizza usam uma estrutura fixa.');
      return;
    }

    const persisted = await this.ensureProductPersisted('Não foi possível salvar o produto antes de criar o adicional.');
    if (!persisted) return;

    const target = this.editingGroupId != null
      ? this.editor.groups.find((grupo) => String(grupo.id) === String(this.editingGroupId))
      : null;

    let grupo = target;
    if (!grupo) {
      grupo = this.cloneGroup(this.groupDraft);
      this.editor.groups.push(grupo);
    }

    grupo.name = this.groupDraft.name || 'Novo adicional';
    grupo.type = this.groupDraft.type;
    grupo.required = this.groupDraft.required;
    grupo.min = Number(this.groupDraft.min || 0);
    grupo.max = Number(this.groupDraft.max || 1);
    grupo.chargeType = this.groupDraft.chargeType;
    grupo.shared = this.groupDraft.shared;
    grupo.description = this.describeDraft(grupo);

    if (!target && this.draftOptions.length > 0) {
      grupo.options = this.draftOptions.map((opt, i) => ({
        ...opt, order: i,
        raw: { nome: opt.name, valor: opt.price, disponivel: opt.active, nova: true }
      }));
    }

    try {
      await this.markSaving();
      await this.facade.salveGrupo(this.empresa.catalogo, this.editor.raw, grupo);

      if (grupo.kind === 'adicional' && grupo.raw) {
        this.editor.raw.camposAdicionais = this.editor.raw.camposAdicionais || [];
        const existing = (this.editor.raw.camposAdicionais || []).find((item: any) => item.id === grupo.raw.id);
        if (!existing) {
          this.editor.raw.camposAdicionais.push(grupo.raw);
        }
      }

      const savedGroupId = grupo.raw?.id ?? grupo.id ?? null;
      const savedGroupName = grupo.name;

      await this.recarregueEditor();

      if (this.isGroupDetailSurface) {
        const persistedGroup = this.editor.groups.find((item) => {
          if (savedGroupId != null && item.id != null) {
            return String(item.id) === String(savedGroupId);
          }

          return item.name === savedGroupName;
        }) || null;

        this.groupDraft = persistedGroup ? this.cloneGroup(persistedGroup) : this.buildEmptyGroupDraft();
        this.editingGroupId = persistedGroup?.id ?? null;

        if (this.embedded) {
          this.requestSurfaceChange('group-detail', persistedGroup?.id ?? null, persistedGroup ? 'edit' : 'create', this.libraryOpen);
        }
      } else {
        this.closeGroupPanel();
      }

      this.draftOptions = [];
      this.draftOptionInput = '';
      this.markSaved();
      this.notificationService.showSuccess('Adicional salvo.');
    } catch (error: any) {
      this.handleSaveError(error, 'Não foi possível salvar o adicional.');
    }
  }

  async removeGroup(grupo: ChoiceGroupVM) {
    if (!this.editor || grupo.kind === 'pizza-sizes') return;
    if (!this.podeEditarEstruturaAdicional) {
      this.notifySharedCatalogBlocked('A exclusão de adicionais está bloqueada neste catálogo compartilhado.');
      return;
    }
    const ok = window.confirm(`Excluir o adicional "${grupo.name}"?`);
    if (!ok) return;

    try {
      await this.markSaving();
      await this.facade.removaGrupo(this.editor.raw, this.empresa.catalogo, grupo);
      this.editor.groups = this.editor.groups.filter((item) => item !== grupo);
      this.editor.raw.camposAdicionais = (this.editor.raw.camposAdicionais || []).filter((item: any) => item.id !== grupo.raw?.id);
      await this.recarregueEditor(false);

      if (this.isGroupDetailSurface) {
        this.groupDraft = null;
        this.editingGroupId = null;

        if (this.embedded) {
          this.requestSurfaceChange('overview');
        } else {
          await this.router.navigate([], {
            relativeTo: this.activatedRoute,
            queryParams: {
              surface: null,
              grupo: null,
              groupMode: null,
              library: null
            },
            queryParamsHandling: 'merge',
            replaceUrl: true
          });
        }
      }

      this.markSaved();
      this.notificationService.showSuccess('Adicional removido.');
    } catch (error: any) {
      this.handleSaveError(error, 'Não foi possível remover o adicional.');
    }
  }

  async addOption(grupo: ChoiceGroupVM) {
    if (!this.editor || grupo.kind === 'pizza-sizes') return;
    if (!this.podeEditarEstruturaAdicional) {
      this.notifySharedCatalogBlocked('A inclusão de opções está bloqueada neste catálogo compartilhado.');
      return;
    }
    const editableGroup = grupo.shared ? await this.prepareSharedGroup(grupo) : grupo;
    if (!editableGroup) return;

    const option: ChoiceOptionVM = {
      id: null,
      name: '',
      price: 0,
      active: true,
      order: editableGroup.options.length,
      raw: { nova: true }
    };

    this.syncOptionToRaw(editableGroup, option, false);
    editableGroup.options.push(option);
    if (!editableGroup.raw.opcoesDisponiveis) editableGroup.raw.opcoesDisponiveis = [];
    editableGroup.raw.opcoesDisponiveis.push(option.raw);
    this.scheduleGroupSave(editableGroup);
  }

  addDraftOptionFromInput(): void {
    const name = this.draftOptionInput.trim();
    if (!name) return;
    this.draftOptions.push({
      id: null, name, price: 0, active: true,
      order: this.draftOptions.length, raw: { nova: true }
    });
    this.draftOptionInput = '';
  }

  removeDraftOption(index: number): void {
    this.draftOptions.splice(index, 1);
    this.draftOptions.forEach((opt, i) => opt.order = i);
  }

  onOptionChanged(grupo: ChoiceGroupVM, option: ChoiceOptionVM, changeType: 'structure' | 'price' | 'availability' = 'structure') {
    if (changeType === 'structure' && !this.podeEditarEstruturaAdicional) {
      this.notifySharedCatalogBlocked('A estrutura da opção está bloqueada neste catálogo compartilhado.');
      return;
    }

    if (changeType === 'price' && !this.podeEditarPrecoOpcoes) {
      this.notifySharedCatalogBlocked('O preço da opção está bloqueado neste catálogo compartilhado.');
      return;
    }

    if (changeType === 'availability' && !this.podeEditarDisponibilidadeOpcoes) {
      this.notifySharedCatalogBlocked('A disponibilidade da opção está bloqueada neste catálogo compartilhado.');
      return;
    }

    this.syncOptionToRaw(grupo, option);
    this.scheduleGroupSave(grupo);
  }

  removeOption(grupo: ChoiceGroupVM, option: ChoiceOptionVM) {
    if (grupo.kind === 'pizza-sizes') return;
    if (!this.podeEditarEstruturaAdicional) {
      this.notifySharedCatalogBlocked('A exclusão de opções está bloqueada neste catálogo compartilhado.');
      return;
    }

    this.syncOptionToRaw(grupo, option, false);
    if (option.raw?.id) {
      option.raw.removida = true;
      delete option.raw.atualizar;
    } else if (grupo.raw?.opcoesDisponiveis) {
      grupo.raw.opcoesDisponiveis = grupo.raw.opcoesDisponiveis.filter((rawOption: any) => rawOption !== option.raw);
    }

    grupo.options = grupo.options.filter((item) => item !== option);
    this.scheduleGroupSave(grupo);
  }

  onBasicInfoChange() {
    if (!this.editor || (!this.podeEditarProdutos && !this.podeEditarPrecos)) return;
    this.syncBasicInfoToRaw();

    if (this.isNewProduct) return;

    if (this.infoTimer) clearTimeout(this.infoTimer);
    this.infoTimer = setTimeout(async () => {
      try {
        await this.markSaving();
        await this.facade.salveProduto(this.editor!.raw);
        await this.syncResolvedProductState(true);
        await this.recarregueEditor(false);
        this.markSaved();
      } catch (error: any) {
        this.handleSaveError(error, 'Não foi possível salvar as informações básicas.');
      }
    }, 800);
  }

  async saveNewProduct() {
    if (!this.editor) return;
    if (!this.podeEditarProdutos) {
      this.notifySharedCatalogBlocked('A criação de produtos está bloqueada neste catálogo compartilhado.');
      return;
    }
    this.syncBasicInfoToRaw();

    if (!this.editor.name?.trim()) {
      this.notificationService.showError('Informe o nome do produto.');
      return;
    }

    try {
      await this.markSaving();
      await this.facade.salveProduto(this.editor.raw);
      await this.syncResolvedProductState(true);

      if (this.creationImagePreview && this.editor.raw?.id) {
        await this.uploadCreationImage();
      }

      this.isNewProduct = false;
      this.creationImagePreview = null;
      await this.recarregueEditor(false);
      this.markSaved();
    } catch (error: any) {
      this.handleSaveError(error, 'Não foi possível salvar o produto.');
    }
  }

  onCreationImageSelected(event: Event) {
    const input = event.target as HTMLInputElement;
    if (!input.files?.length) return;
    const file = input.files[0];

    const validTypes = ['image/jpeg', 'image/png'];
    if (!validTypes.includes(file.type)) {
      this.notificationService.showError('Formato inválido. Use JPG ou PNG.');
      return;
    }
    if (file.size > 5 * 1024 * 1024) {
      this.notificationService.showError('Imagem muito grande. Máximo 5MB.');
      return;
    }

    const reader = new FileReader();
    reader.onload = (e) => {
      this.creationImagePreview = e.target?.result as string;
    };
    reader.readAsDataURL(file);
  }

  private uploadCreationImage(): Promise<void> {
    if (!this.creationImagePreview) return Promise.resolve();

    return new Promise((resolve, reject) => {
      const blob = this.dataURItoBlob(this.creationImagePreview!);
      const formData = new FormData();
      formData.append('image', blob);

      this.httpClient.post<any>('/upload/imagens/crop/800', formData).subscribe(
        (response) => {
          if (!this.editor!.raw.imagens) {
            this.editor!.raw.imagens = [];
          }
          this.editor!.raw.imagens.push(response.data);
          this.facade.salveImagensProduto(this.empresa, this.editor!.raw).then(resolve).catch(reject);
        },
        (error) => {
          console.error('Erro ao fazer upload da imagem de criação:', error);
          resolve();
        }
      );
    });
  }

  private dataURItoBlob(dataURI: string): Blob {
    const byteString = atob(dataURI.split(',')[1]);
    const mimeString = dataURI.split(',')[0].split(':')[1].split(';')[0];
    const ab = new ArrayBuffer(byteString.length);
    const ia = new Uint8Array(ab);
    for (let i = 0; i < byteString.length; i++) {
      ia[i] = byteString.charCodeAt(i);
    }
    return new Blob([ab], { type: mimeString });
  }

  onDisponibilidadeTipoChange() {
    if (!this.editor || !this.podeEditarProdutos) return;
    this.editor.availability.active = this.editor.availability.disponibilidadeTipo !== 2;
    this.onAvailabilityChange();
  }

  onAvailabilityChange() {
    if (!this.editor || !this.podeEditarProdutos) return;
    this.facade.apliqueDisponibilidade(this.editor.raw, this.editor.availability);

    if (this.availabilityTimer) clearTimeout(this.availabilityTimer);
    this.availabilityTimer = setTimeout(async () => {
      try {
        await this.markSaving();
        await this.facade.salveDisponibilidade(this.empresa.catalogo, this.editor!.raw);
        await this.recarregueEditor(false);
        this.markSaved();
      } catch (error: any) {
        this.handleSaveError(error, 'Não foi possível salvar a disponibilidade.');
      }
    }, 500);
  }

  onClassificationChange(tagName?: string) {
    if (!this.editor || !this.podeEditarProdutos) return;

    this.facade.apliqueDestaque(this.editor.raw, this.editor.classification.destaque);
    if (tagName) {
      const alreadySelected = this.editor.classification.tags.includes(tagName);
      this.editor.classification.tags = alreadySelected
        ? this.editor.classification.tags.filter((tag) => tag !== tagName)
        : [...this.editor.classification.tags, tagName];
    }

    if (this.classificationTimer) clearTimeout(this.classificationTimer);
    this.classificationTimer = setTimeout(async () => {
      try {
        const persisted = await this.ensureProductPersisted('Não foi possível salvar o produto antes de atualizar a classificação.');
        if (!persisted) return;

        const tags = this.availableTags.filter((tag) => this.editor!.classification.tags.includes(tag.nome));
        await this.markSaving();
        await this.facade.salveProduto(this.editor!.raw);
        await this.facade.salveTags(this.empresa.catalogo, this.editor!.raw, tags);
        await this.recarregueEditor(false);
        this.markSaved();
      } catch (error: any) {
        this.handleSaveError(error, 'Não foi possível salvar a classificação.');
      }
    }, 500);
  }

  alterouNovoPreco() {
    if (!this.editor || !this.podeEditarPrecos) return;
    const preco = this.editor.raw.preco || 0;
    if (preco > 0 && this.editor.promotion.novoPreco != null) {
      this.editor.promotion.percentualDesconto = Number((100 - (this.editor.promotion.novoPreco / preco) * 100).toFixed(2));
    }
    this.syncPromotionToRaw();
    this.schedulePromotionSave();
  }

  alterouPercentualDesconto() {
    if (!this.editor || !this.podeEditarPrecos) return;
    const preco = this.editor.raw.preco || 0;
    if (preco > 0 && this.editor.promotion.percentualDesconto != null) {
      const desconto = preco * (this.editor.promotion.percentualDesconto / 100);
      this.editor.promotion.novoPreco = Number((preco - desconto).toFixed(2));
    }
    this.syncPromotionToRaw();
    this.schedulePromotionSave();
  }

  alterouNovoPrecoNaEmpresa() {
    if (!this.editor || !this.podeEditarPrecos) return;
    const preco = this.editor.raw.precoNaEmpresa || 0;
    if (preco > 0 && this.editor.promotion.novoPrecoNaEmpresa != null) {
      this.editor.promotion.percentualDescontoNaEmpresa = Number((100 - (this.editor.promotion.novoPrecoNaEmpresa / preco) * 100).toFixed(2));
    }
    this.syncPromotionToRaw();
    this.schedulePromotionSave();
  }

  alterouPercentualDescontoNaEmpresa() {
    if (!this.editor || !this.podeEditarPrecos) return;
    const preco = this.editor.raw.precoNaEmpresa || 0;
    if (preco > 0 && this.editor.promotion.percentualDescontoNaEmpresa != null) {
      const desconto = preco * (this.editor.promotion.percentualDescontoNaEmpresa / 100);
      this.editor.promotion.novoPrecoNaEmpresa = Number((preco - desconto).toFixed(2));
    }
    this.syncPromotionToRaw();
    this.schedulePromotionSave();
  }

  inserirDesconto() {
    if (!this.editor || !this.podeEditarPrecos) return;
    this.editor.promotion.exibirDescontos = true;
  }

  removerDesconto() {
    if (!this.editor || !this.podeEditarPrecos) return;
    this.editor.promotion.exibirDescontos = false;

    if (this.precoPorEmpresa) {
      delete this.editor.raw.percentualDescontoNaEmpresa;
      delete this.editor.raw.novoPrecoNaEmpresa;
      this.editor.promotion.novoPrecoNaEmpresa = null;
      this.editor.promotion.percentualDescontoNaEmpresa = null;
    } else {
      delete this.editor.raw.percentualDesconto;
      delete this.editor.raw.novoPreco;
      this.editor.promotion.novoPreco = null;
      this.editor.promotion.percentualDesconto = null;
    }

    this.editor.raw.destaque = false;
    this.editor.classification.destaque = false;
    this.schedulePromotionSave();
  }

  private syncPromotionToRaw() {
    if (!this.editor) return;

    if (this.precoPorEmpresa) {
      this.editor.raw.novoPrecoNaEmpresa = this.editor.promotion.novoPrecoNaEmpresa;
      this.editor.raw.percentualDescontoNaEmpresa = this.editor.promotion.percentualDescontoNaEmpresa;
    } else {
      this.editor.raw.novoPreco = this.editor.promotion.novoPreco;
      this.editor.raw.percentualDesconto = this.editor.promotion.percentualDesconto;
    }
  }

  private schedulePromotionSave() {
    if (this.promotionTimer) clearTimeout(this.promotionTimer);
    this.promotionTimer = setTimeout(async () => {
      try {
        await this.markSaving();
        await this.facade.salveProduto(this.editor!.raw);
        await this.recarregueEditor(false);
        this.markSaved();
      } catch (error: any) {
        this.handleSaveError(error, 'Não foi possível salvar a promoção.');
      }
    }, 500);
  }

  alterouNovoPrecoTamanho(option: ChoiceOptionVM) {
    if (!option.raw || !this.podeEditarPrecoOpcoes) return;
    const preco = option.raw.preco || option.price || 0;
    if (preco > 0 && option.novoPreco != null) {
      option.percentualDesconto = Number((100 - (option.novoPreco / preco) * 100).toFixed(2));
    }
    this.syncPizzaSizeToRaw(option);
    this.schedulePromotionSave();
  }

  alterouPercentualDescontoTamanho(option: ChoiceOptionVM) {
    if (!option.raw || !this.podeEditarPrecoOpcoes) return;
    const preco = option.raw.preco || option.price || 0;
    if (preco > 0 && option.percentualDesconto != null) {
      const desconto = preco * (option.percentualDesconto / 100);
      option.novoPreco = Number((preco - desconto).toFixed(2));
    }
    this.syncPizzaSizeToRaw(option);
    this.schedulePromotionSave();
  }

  removerDescontoTamanho(option: ChoiceOptionVM) {
    if (!option.raw || !this.podeEditarPrecoOpcoes) return;
    delete option.raw.novoPreco;
    delete option.raw.percentualDesconto;
    option.raw.destaque = false;
    option.novoPreco = null;
    option.percentualDesconto = null;
    option.destaque = false;
    this.schedulePromotionSave();
  }

  private syncPizzaSizeToRaw(option: ChoiceOptionVM) {
    if (!option.raw) return;
    option.raw.codigoPdv = option.codigoPdv;
    option.raw.novoPreco = option.novoPreco;
    option.raw.percentualDesconto = option.percentualDesconto;
    option.raw.destaque = option.destaque;
  }

  async onFiscalSectionToggle() {
    this.sectionFiscalOpen = !this.sectionFiscalOpen;
    if (this.sectionFiscalOpen && !this.dadosFiscais && !this.fiscalLoading) {
      this.fiscalLoading = true;
      try {
        this.dadosFiscais = await this.facade.carregueDadosFiscais();
      } finally {
        this.fiscalLoading = false;
      }
    }
  }

  onFiscalChange() {
    if (!this.editor || !this.podeEditarProdutos) return;
    this.syncFiscalToRaw();

    if (this.fiscalTimer) clearTimeout(this.fiscalTimer);
    this.fiscalTimer = setTimeout(async () => {
      try {
        const persisted = await this.ensureProductPersisted('Não foi possível salvar o produto antes de atualizar o fiscal.');
        if (!persisted) return;
        await this.markSaving();
        await this.facade.salveFiscal(this.editor!.raw);
        this.markSaved();
      } catch (error: any) {
        this.handleSaveError(error, 'Não foi possível salvar as configurações fiscais.');
      }
    }, 800);
  }

  onFidelidadeChange() {
    if (!this.editor || !this.podeEditarProdutos) return;
    this.editor.raw.pontosGanhos = this.editor.fidelidade.pontosGanhos;
    this.editor.raw.cashback = this.editor.fidelidade.cashback;

    if (this.fidelidadeTimer) clearTimeout(this.fidelidadeTimer);
    this.fidelidadeTimer = setTimeout(async () => {
      try {
        const persisted = await this.ensureProductPersisted('Não foi possível salvar o produto antes de atualizar a fidelidade.');
        if (!persisted) return;
        await this.markSaving();
        await this.facade.salvePontosFidelidade(this.editor!.raw);
        this.markSaved();
      } catch (error: any) {
        this.handleSaveError(error, 'Não foi possível salvar a pontuação fidelidade.');
      }
    }, 800);
  }

  private syncFiscalToRaw() {
    if (!this.editor) return;
    if (!this.editor.raw.configuracaoFiscal) {
      this.editor.raw.configuracaoFiscal = {};
    }
    const config = this.editor.raw.configuracaoFiscal;
    const fiscal = this.editor.fiscal;
    config.origem = fiscal.origem;
    config.cest = fiscal.cest;
    config.ncm = fiscal.ncm;
    config.gtin = fiscal.gtin;
    config.unidade = fiscal.unidade;
    config.tipoCalculoIPI = fiscal.tipoCalculoIPI;
    config.aliquotaIPI = fiscal.aliquotaIPI;
    config.valorPorUnidadeIPI = fiscal.valorPorUnidadeIPI;
    config.tipoDeTributacaoIPI = fiscal.tipoDeTributacaoIPI;
    config.seloDeControleIPI = fiscal.seloDeControleIPI;
    config.producaoPropria = fiscal.producaoPropria;
    config.ipiCompoeBaseCalculoICMS = fiscal.ipiCompoeBaseCalculoICMS;
    config.aliquotaAtributosAproximados = fiscal.aliquotaAtributosAproximados;
    config.informacoesAdicionais = fiscal.informacoesAdicionais;
  }

  async useLibraryGroup(group: LibraryGroupVM, clonar: boolean) {
    if (!this.podeEditarProdutos) {
      this.notifySharedCatalogBlocked('A biblioteca está bloqueada neste catálogo compartilhado.');
      return;
    }
    const persisted = await this.ensureProductPersisted('Não foi possível salvar o produto antes de usar a biblioteca.');
    if (!persisted) return;

    try {
      await this.markSaving();
      await this.facade.vinculeGrupoDaBiblioteca(this.empresa.catalogo, this.editor!.raw, group, clonar);
      await this.recarregueEditor();
      if (this.isGroupDetailSurface) {
        const newestGroup = [...(this.editor?.groups || [])].sort((a, b) => (b.order || 0) - (a.order || 0))[0] || null;
        this.groupDraft = newestGroup ? this.cloneGroup(newestGroup) : this.buildEmptyGroupDraft();
        this.editingGroupId = newestGroup?.id ?? null;

        if (this.embedded) {
          this.requestSurfaceChange('group-detail', newestGroup?.id ?? null, newestGroup ? 'edit' : 'create');
        }
      }
      this.markSaved();
      this.closeLibrary();
      this.notificationService.showSuccess(clonar ? 'Adicional duplicado da biblioteca.' : 'Adicional vinculado da biblioteca.');
    } catch (error: any) {
      this.handleSaveError(error, 'Não foi possível usar o adicional da biblioteca.');
    }
  }

  async reorderGroups(event: CdkDragDrop<ChoiceGroupVM[]>) {
    if (!this.editor || event.previousIndex === event.currentIndex) return;
    if (!this.podeEditarEstruturaAdicional) {
      this.notifySharedCatalogBlocked('A ordem dos adicionais está bloqueada neste catálogo compartilhado.');
      return;
    }

    moveItemInArray(this.editor.groups, event.previousIndex, event.currentIndex);
    this.editor.groups.forEach((grupo, index) => {
      grupo.order = index;
    });

    try {
      await this.markSaving();
      await this.facade.reordeneGrupos(this.empresa.catalogo, this.editor.raw, this.editor.groups);
      await this.recarregueEditor(false);
      this.markSaved();
      this.notificationService.showSuccess('Ordem dos adicionais atualizada.');
    } catch (error: any) {
      this.handleSaveError(error, 'Não foi possível reordenar os adicionais.');
    }
  }

  openReorderSheet(): void {
    if (!this.editor || !this.podeEditarEstruturaAdicional) return;
    const seen = new Set<string | number>();
    this.reorderList = this.editor.groups.filter((g) => {
      if (g.kind === 'pizza-sizes') return false;
      if (seen.has(g.id)) return false;
      seen.add(g.id);
      return true;
    });
    this.reorderDirty = false;
    this.reorderSheetOpen = true;
  }

  closeReorderSheet(): void {
    if (this.reorderDirty) {
      this.reorderShaking = false;
      requestAnimationFrame(() => {
        this.reorderShaking = true;
        setTimeout(() => this.reorderShaking = false, 500);
      });
      this.reorderErrorMsg = 'Salve ou descarte as alterações antes de fechar.';
      this.notificationService.showError('Você tem alterações pendentes. Clique em "Aplicar" para salvar ou "Cancelar" para descartar.');
      return;
    }
    this.forceCloseReorderSheet();
  }

  forceCloseReorderSheet(): void {
    this.reorderSheetOpen = false;
    this.reorderList = [];
    this.reorderDirty = false;
    this.reorderShaking = false;
    this.reorderErrorMsg = '';
  }

  onReorderDrop(event: CdkDragDrop<ChoiceGroupVM[]>): void {
    if (event.previousIndex === event.currentIndex) return;
    moveItemInArray(this.reorderList, event.previousIndex, event.currentIndex);
    this.reorderDirty = true;
  }

  async applyReorder(): Promise<void> {
    if (!this.editor || !this.reorderDirty || this.reorderApplying) return;
    this.reorderApplying = true;

    this.reorderList.forEach((grupo, index) => {
      grupo.order = index;
    });

    try {
      await this.markSaving();
      await this.facade.reordeneGrupos(this.empresa.catalogo, this.editor.raw, this.reorderList);
      await this.recarregueEditor(false);
      this.markSaved();
      this.notificationService.showSuccess('Ordem dos adicionais atualizada.');
      this.reorderErrorMsg = '';
      this.forceCloseReorderSheet();
    } catch (error: any) {
      this.handleSaveError(error, 'Não foi possível reordenar os adicionais.');
    } finally {
      this.reorderApplying = false;
    }
  }

  trackByGroup(index: number, group: ChoiceGroupVM) {
    return group.id || index;
  }

  trackByOption(index: number, option: ChoiceOptionVM) {
    return option.id || index;
  }

  isDenseGroup(group: ChoiceGroupVM | null | undefined): boolean {
    return !!group && (group.options?.length || 0) >= this.mobileDenseGroupThreshold;
  }

  shouldUseDenseGroupSummary(group: ChoiceGroupVM | null | undefined): boolean {
    return !this.embedded && this.isMobile && !!group;
  }

  getGroupActiveOptionCount(group: ChoiceGroupVM | null | undefined): number {
    return (group?.options || []).filter((option) => option.active !== false).length;
  }

  getGroupInactiveOptionCount(group: ChoiceGroupVM | null | undefined): number {
    return Math.max((group?.options?.length || 0) - this.getGroupActiveOptionCount(group), 0);
  }

  getGroupOptionPreview(group: ChoiceGroupVM): string {
    const names = (group.options || [])
      .filter((option) => option.active !== false)
      .map((option) => option.name)
      .filter((name) => !!name);

    if (!names.length) {
      return 'Sem opções configuradas';
    }

    return names.slice(0, 3).join(', ');
  }

  getGroupOptionNames(group: ChoiceGroupVM): string[] {
    return (group.options || [])
      .filter(o => o.active !== false && !!o.name)
      .map(o => o.name)
      .slice(0, 3);
  }

  getGroupOptionRemainingCount(group: ChoiceGroupVM): number {
    const count = (group.options || [])
      .filter((option) => option.active !== false)
      .filter((option) => !!option.name)
      .length;
    return Math.max(count - 3, 0);
  }

  openGroupDetail(
    group?: ChoiceGroupVM,
    groupDraftMode: ProductEditorGroupDraftModeV2 | null = 'edit',
    startWithLibrary = false,
    optionMode: ProductEditorOptionModeV2 = 'review'
  ) {
    this.resetOptionBrowserState();
    this.optionMode = optionMode;
    this.requestSurfaceChange('group-detail', group?.id ?? null, group ? groupDraftMode : 'create', startWithLibrary, optionMode);
  }

  setOptionFilter(filter: 'all' | 'active' | 'inactive') {
    this.optionFilter = filter;
    this.persistOptionState();
  }

  setOptionMode(mode: ProductEditorOptionModeV2) {
    const previousMode = this.optionMode;
    this.optionMode = mode;
    if (previousMode === 'batch-price' && mode !== 'batch-price') {
      this.clearBatchSelection();
      this.closeBatchSheet();
    }
    if (mode !== 'review') {
      this.editSheetOpen = false;
      this.commitEditingOption();
    }
    this.persistOptionState();
  }

  setOptionSearch(value: string) {
    this.optionSearch = value;
    this.persistOptionState();
  }

  setOptionSort(sort: ProductEditorOptionSortV2) {
    this.optionSort = sort;
    this.persistOptionState();
  }

  addOptionFromFocusedGroup() {
    if (!this.focusedGroup) return;
    this.resetOptionBrowserState();
    void this.addOption(this.focusedGroup);
  }

  isBatchOptionSelected(option: ChoiceOptionVM): boolean {
    return !!this.batchSelection[this.getOptionRuntimeKey(option)];
  }

  toggleBatchOption(option: ChoiceOptionVM, checked?: boolean) {
    const key = this.getOptionRuntimeKey(option);
    const nextValue = typeof checked === 'boolean' ? checked : !this.batchSelection[key];

    if (nextValue) {
      this.batchSelection[key] = true;
      return;
    }

    delete this.batchSelection[key];
  }

  selectAllFilteredBatchOptions() {
    this.filteredFocusedGroupOptions.forEach((option) => {
      this.batchSelection[this.getOptionRuntimeKey(option)] = true;
    });
  }

  clearBatchSelection() {
    this.batchSelection = {};
  }

  applyBatchPresetPrice(price: number) {
    this.batchPriceInput = this.formatMoneyValue(price);
    this.applyBatchPrice(price);
  }

  applyBatchInputPrice() {
    this.applyBatchPrice(this.parseOptionMoney(this.batchPriceInput));
  }

  applyBatchAvailability(active: boolean) {
    const group = this.focusedGroup;
    if (!group) return;
    if (!this.podeEditarDisponibilidadeOpcoes) {
      this.notifySharedCatalogBlocked('A disponibilidade da opção está bloqueada neste catálogo compartilhado.');
      return;
    }

    if (!this.batchSelectedCount) {
      this.notificationService.showError('Selecione pelo menos uma opção.');
      return;
    }

    const action = active ? 'ativar' : 'desativar';
    if (!window.confirm(`Deseja ${action} ${this.batchSelectedCount} opção(ões) selecionada(s)?`)) return;

    (group.options || [])
      .filter((option) => this.isBatchOptionSelected(option))
      .forEach((option) => {
        option.active = active;
        this.syncOptionToRaw(group, option);
      });

    this.scheduleGroupSave(group);
    this.notificationService.showSuccess(active ? 'Opções ativadas em lote.' : 'Opções desativadas em lote.');
  }

  setFilteredOptionsAvailability(active: boolean) {
    const group = this.focusedGroup;
    if (!group) return;
    if (!this.podeEditarDisponibilidadeOpcoes) {
      this.notifySharedCatalogBlocked('A disponibilidade da opção está bloqueada neste catálogo compartilhado.');
      return;
    }

    this.filteredFocusedGroupOptions.forEach((option) => {
      option.active = active;
      this.syncOptionToRaw(group, option);
    });

    this.scheduleGroupSave(group);
    this.notificationService.showSuccess(active ? 'Opções ativadas.' : 'Opções desativadas.');
  }

  get modeThemeClass(): string {
    switch (this.optionMode) {
      case 'activation': return 'is-mode-onoff';
      case 'review': return 'is-mode-editar';
      case 'batch-price': return 'is-mode-lote';
      default: return '';
    }
  }

  get groupActiveCount(): number {
    return this.focusedGroup ? this.getGroupActiveOptionCount(this.focusedGroup) : 0;
  }

  get groupTotalCount(): number {
    return this.focusedGroup?.options?.length || 0;
  }

  isFixedGroup(group: ChoiceGroupVM | null | undefined): boolean {
    return !!group && group.kind === 'pizza-sizes';
  }

  canEditGroupStructure(group: ChoiceGroupVM | null | undefined): boolean {
    return !this.isFixedGroup(group) && this.podeEditarEstruturaAdicional;
  }

  // ── Adicional editor integration ──

  getActiveFocusGroupId(): number | string | null {
    return this.embedded ? this.focusGroupId : this.getContextFocusGroupId();
  }

  getActiveGroupDraftMode(): string | null {
    return this.embedded ? this.groupDraftMode : this.getContextGroupDraftMode();
  }

  async onAdicionalSaved(grupo: ChoiceGroupVM): Promise<void> {
    await this.recarregueEditor();
    this.markSaved();
    this.requestSurfaceChange('overview');
  }

  async onAdicionalDeleted(grupo: ChoiceGroupVM): Promise<void> {
    this.libraryOpen = false;
    this.requestSurfaceChange('overview');
    await this.recarregueEditor();
    this.markSaved();
    this.notificationService.showSuccess('Adicional removido.');
  }

  onAdicionalActionBarStateChange(state: { creationPhase: 'config' | 'full'; saveFooterState: 'hidden' | 'dirty' | 'saving' | 'saved' }): void {
    this.adicionalActionBarState = state;
  }

  onAdicionalActionBarCancel(): void {
    this.adicionalEditorComponent?.onCancel();
  }

  onAdicionalActionBarSave(): void {
    void this.adicionalEditorComponent?.onSave();
  }

  onAdicionalActionBarSaveAndClose(): void {
    void this.adicionalEditorComponent?.onSaveAndClose();
  }

  async onAdicionalDuplicated(): Promise<void> {
    await this.recarregueEditor();

    const newestGroup = [...(this.editor?.groups || [])]
      .filter((item) => item.kind === 'adicional')
      .sort((a, b) => (b.order || 0) - (a.order || 0))[0] || null;

    if (newestGroup) {
      this.requestSurfaceChange('group-detail', newestGroup.id, 'edit', false);
    } else {
      this.requestSurfaceChange('overview');
    }
    this.markSaved();
  }

  handleGroupPrimaryAction(group: ChoiceGroupVM, event?: Event): void {
    if (event) {
      event.stopPropagation();
    }

    if (this.embedded || this.isFixedGroup(group) || !this.canEditGroupStructure(group)) {
      this.openGroupDetail(group);
      return;
    }

    void this.openGroupPanel(group);
  }

  onChipClickOnOff(option: ChoiceOptionVM): void {
    if (!this.podeEditarDisponibilidadeOpcoes) {
      this.notifySharedCatalogBlocked('A disponibilidade da opção está bloqueada neste catálogo compartilhado.');
      return;
    }
    option.active = !option.active;
    if (this.focusedGroup) {
      this.onOptionChanged(this.focusedGroup, option, 'availability');
    }
  }

  onChipClickEditar(option: ChoiceOptionVM): void {
    if (!this.podeEditarAlgumaOpcao) {
      this.notifySharedCatalogBlocked('A edição das opções está bloqueada neste catálogo compartilhado.');
      return;
    }
    this.editingOptionId = option.id ?? option.name;
    this.editingOptionName = option.name;
    this.editingOptionDescription = option.description || '';
    this.editingOptionPrice = option.price;
    this.editingOptionActive = option.active !== false;
    this.editSheetOpen = true;
  }

  getEditingOption(): ChoiceOptionVM | null {
    if (!this.focusedGroup || this.editingOptionId == null) return null;
    return this.focusedGroup.options.find((o) => o.id === this.editingOptionId) || null;
  }

  closeEditSheet(): void {
    this.editSheetOpen = false;
    this.editingOptionId = null;
    this.editingOptionName = '';
    this.editingOptionDescription = '';
    this.editingOptionPrice = null;
    this.editingOptionActive = true;
  }

  saveAndCloseEditSheet(): void {
    this.commitEditingOption();
    this.editSheetOpen = false;
  }

  deleteAndCloseEditSheet(): void {
    if (!this.focusedGroup) return;
    if (!this.podeEditarEstruturaAdicional) {
      this.notifySharedCatalogBlocked('A exclusão de opções está bloqueada neste catálogo compartilhado.');
      return;
    }
    const option = this.focusedGroup.options.find(
      (o) => (o.id ?? o.name) === this.editingOptionId
    );
    if (option) {
      this.removeOption(this.focusedGroup, option);
    }
    this.closeEditSheet();
  }

  onChipClickLote(option: ChoiceOptionVM): void {
    this.toggleBatchOption(option);
  }

  commitEditingOption(): void {
    if (this.editingOptionId == null || !this.focusedGroup) return;
    const option = this.focusedGroup.options.find(
      (o) => (o.id ?? o.name) === this.editingOptionId
    );
    if (option) {
      let changed = false;

      if (this.podeEditarEstruturaAdicional) {
        option.name = this.editingOptionName;
        option.description = this.editingOptionDescription;
        changed = true;
      }

      if (this.podeEditarPrecoOpcoes) {
        option.price = this.editingOptionPrice ?? 0;
        changed = true;
      }

      if (this.podeEditarDisponibilidadeOpcoes) {
        option.active = this.editingOptionActive;
        changed = true;
      }

      if (changed) {
        this.syncOptionToRaw(this.focusedGroup, option);
        this.scheduleGroupSave(this.focusedGroup);
      }
    }
    this.editingOptionId = null;
    this.editingOptionName = '';
    this.editingOptionDescription = '';
    this.editingOptionPrice = null;
  }

  isEditingOption(option: ChoiceOptionVM): boolean {
    return this.editingOptionId === (option.id ?? option.name);
  }

  openBatchSheet(): void {
    if (!this.podeEditarPrecoOpcoes) {
      this.notifySharedCatalogBlocked('O preço em massa está bloqueado neste catálogo compartilhado.');
      return;
    }
    if (!this.batchSelectedCount) {
      this.notificationService.showError('Selecione pelo menos uma opção antes de alterar o preço.');
      return;
    }
    this.batchSheetOpen = true;
    this.batchAdjustMode = 'fixed';
    this.batchAdjustValue = '';
  }

  closeBatchSheet(): void {
    this.batchSheetOpen = false;
    this.batchAdjustValue = '';
  }

  setBatchAdjustMode(mode: BatchPriceAdjustMode): void {
    this.batchAdjustMode = mode;
    this.batchAdjustValue = '';
  }

  applyBatchAdjust(): void {
    const group = this.focusedGroup;
    if (!group || !this.batchSelectedCount) return;
    if (!this.podeEditarPrecoOpcoes) {
      this.notifySharedCatalogBlocked('O preço em massa está bloqueado neste catálogo compartilhado.');
      return;
    }

    const rawValue = this.parseOptionMoney(this.batchAdjustValue);

    (group.options || [])
      .filter((option) => this.isBatchOptionSelected(option))
      .forEach((option) => {
        let newPrice: number;
        switch (this.batchAdjustMode) {
          case 'fixed':
            newPrice = rawValue;
            break;
          case 'increment':
            newPrice = Math.max(0, Number(option.price || 0) + rawValue);
            break;
          case 'percent':
            newPrice = Math.max(0, Number(option.price || 0) * (1 + rawValue / 100));
            newPrice = Math.round(newPrice * 100) / 100;
            break;
          default:
            newPrice = rawValue;
        }
        option.price = newPrice;
        this.syncOptionToRaw(group, option);
      });

    this.scheduleGroupSave(group);
    this.closeBatchSheet();
    this.notificationService.showSuccess('Preço ajustado em lote.');
  }

  private describeDraft(grupo: ChoiceGroupVM): string {
    if (grupo.type === 'single') {
      return `Escolha 1 • ${grupo.options.length} opções`;
    }

    return `Até ${grupo.max} • ${grupo.options.length} opções`;
  }

  private groupKey(grupo: ChoiceGroupVM): string {
    return `${grupo.kind}-${grupo.id}`;
  }

  private syncOptionToRaw(grupo: ChoiceGroupVM, option: ChoiceOptionVM, markUpdated = true) {
    if (!this.editor) return;

    option.raw = option.raw || {};
    option.raw.nome = option.name;
    option.raw.descricao = option.description || '';

    this.facade.apliqueEstadoOpcao(this.editor.raw, option.raw, {
      price: Number(option.price || 0),
      active: option.active
    });

    if (grupo.kind === 'pizza-sizes') {
      option.raw.preco = Number(option.price || 0);
      option.raw.disponivel = option.active;
      return;
    }

    if (option.raw.id) {
      delete option.raw.nova;
      if (markUpdated && !option.raw.removida) {
        option.raw.atualizar = true;
      }
      return;
    }

    option.raw.nova = true;
    delete option.raw.atualizar;
  }

  private cloneGroup(grupo: ChoiceGroupVM): ChoiceGroupVM {
    return JSON.parse(JSON.stringify(grupo));
  }

  private async prepareSharedGroup(grupo: ChoiceGroupVM): Promise<ChoiceGroupVM | null> {
    if (!this.editor) return null;

    const editarParaTodos = window.confirm(
      'Adicional compartilhado. Clique em OK para editar em todos os produtos. Clique em Cancelar para duplicar e editar apenas neste produto.'
    );

    if (editarParaTodos) return grupo;

    const clone = this.cloneGroup(grupo);
    clone.id = null;
    clone.shared = false;
    clone.sharedCount = 0;
    clone.raw = null;
    clone.options = clone.options.map((option, index) => ({
      ...option,
      id: null,
      order: index,
      raw: {
        nome: option.name,
        valor: option.price,
        disponivel: option.active,
        nova: true
      }
    }));

    try {
      const persisted = await this.ensureProductPersisted('Não foi possível salvar o produto antes de duplicar o adicional.');
      if (!persisted) return null;

      await this.markSaving();
      await this.facade.salveGrupo(this.empresa.catalogo, this.editor.raw, clone);
      if (clone.raw) {
        this.editor.raw.camposAdicionais = this.editor.raw.camposAdicionais || [];
        this.editor.raw.camposAdicionais.push(clone.raw);
      }
      await this.facade.removaGrupo(this.editor.raw, this.empresa.catalogo, grupo);
      this.editor.raw.camposAdicionais = (this.editor.raw.camposAdicionais || []).filter((item: any) => item.id !== grupo.raw?.id);
      await this.recarregueEditor();
      this.markSaved();
      this.notificationService.showSuccess('Adicional compartilhado duplicado para edição local.');
    } catch (error: any) {
      this.handleSaveError(error, 'Não foi possível duplicar o adicional compartilhado.');
      return null;
    }

    return this.editor.groups.find((current) => current.id === clone.id) || this.editor.groups.find((current) => current.name === clone.name) || null;
  }

  private scheduleGroupSave(grupo: ChoiceGroupVM) {
    if (!this.editor) return;

    const timerKey = this.groupKey(grupo);
    if (this.groupTimers[timerKey]) clearTimeout(this.groupTimers[timerKey]);
    this.groupTimers[timerKey] = setTimeout(async () => {
      try {
        grupo.description = this.describeDraft(grupo);
        const persisted = await this.ensureProductPersisted('Não foi possível salvar o produto antes de atualizar as opções do adicional.');
        if (!persisted) return;

        await this.markSaving();
        await this.facade.salveGrupo(this.empresa.catalogo, this.editor!.raw, grupo);
        if (grupo.kind === 'adicional' && grupo.raw) {
          this.editor!.raw.camposAdicionais = this.editor!.raw.camposAdicionais || [];
          const exists = (this.editor!.raw.camposAdicionais || []).find((item: any) => item.id === grupo.raw.id);
          if (!exists) {
            this.editor!.raw.camposAdicionais.push(grupo.raw);
          }
        }
        await this.recarregueEditor(false);
        this.markSaved();
      } catch (error: any) {
        this.handleSaveError(error, 'Não foi possível salvar as opções do adicional.');
      }
    }, 800);
  }

  private async markSaving() {
    this.saveState = 'Salvando...';
    this.saveStateMuted = false;
  }

  private markSaved() {
    this.saveState = 'Salvo agora';
    this.saveStateMuted = true;
    this.productPersisted.emit();
  }

  private handleSaveError(error: any, fallbackMessage: string) {
    this.saveState = 'Erro ao salvar';
    this.saveStateMuted = false;
    this.notificationService.showError(error?.message || fallbackMessage);
  }

  private async syncContextLoad(force = false) {
    const signature = this.getLoadSignature();
    if (!force && signature === this.lastLoadSignature) {
      return;
    }

    this.lastLoadSignature = signature;
    await this.carregueTela();
  }

  private getContextProductId(): number | null {
    if (this.embedded) {
      return this.productId != null ? Number(this.productId) : null;
    }

    const id = this.activatedRoute.snapshot.params.id;
    return id != null ? Number(id) : null;
  }

  private getContextProductType(): ProductTypeV2 {
    if (this.embedded) {
      return this.newProductType || 'normal';
    }

    return (this.activatedRoute.snapshot.queryParams.tipo || 'normal') as ProductTypeV2;
  }

  private shouldStartWithPreview(): boolean {
    return this.embedded ? this.startWithPreview : !!this.activatedRoute.snapshot.queryParams.preview;
  }

  private shouldStartWithLibrary(): boolean {
    return this.embedded
      ? this.startWithLibrary
      : !!(this.activatedRoute.snapshot.queryParams.drawerLibrary || this.activatedRoute.snapshot.queryParams.library);
  }

  private getContextOptionMode(): ProductEditorOptionModeV2 | null {
    if (this.embedded) {
      return this.requestedOptionMode;
    }

    return (this.activatedRoute.snapshot.queryParams.drawerOptionsMode
      || this.activatedRoute.snapshot.queryParams.optionsMode
      || null) as ProductEditorOptionModeV2 | null;
  }

  private getContextFocusGroupId(): number | string | null {
    if (this.embedded) {
      return this.focusGroupId;
    }

    const focusGroupId = this.activatedRoute.snapshot.queryParams.drawerGroup
      || this.activatedRoute.snapshot.queryParams.grupo;
    return focusGroupId != null ? focusGroupId : null;
  }

  private getContextGroupDraftMode(): ProductEditorGroupDraftModeV2 | null {
    if (this.embedded) {
      return this.groupDraftMode;
    }

    return (this.activatedRoute.snapshot.queryParams.drawerGroupMode
      || this.activatedRoute.snapshot.queryParams.groupMode
      || null) as ProductEditorGroupDraftModeV2 | null;
  }

  private getLoadSignature(): string {
    return JSON.stringify({
      embedded: this.embedded,
      productId: this.productId,
      newProductType: this.newProductType,
      startWithPreview: this.startWithPreview,
      startWithLibrary: this.startWithLibrary,
      surfaceMode: this.surfaceMode,
      focusGroupId: this.focusGroupId,
      groupDraftMode: this.groupDraftMode,
      requestedOptionMode: this.requestedOptionMode,
      routeProductId: this.embedded ? null : this.activatedRoute.snapshot.params.id || null,
      routeNewProductType: this.embedded ? null : this.activatedRoute.snapshot.queryParams.tipo || null,
      routePreview: this.embedded ? null : this.activatedRoute.snapshot.queryParams.preview || null,
      routeLibrary: this.embedded ? null : this.activatedRoute.snapshot.queryParams.drawerLibrary || this.activatedRoute.snapshot.queryParams.library || null,
      routeFocusGroupId: this.embedded ? null : this.activatedRoute.snapshot.queryParams.drawerGroup || this.activatedRoute.snapshot.queryParams.grupo || null,
      routeSurface: this.embedded ? null : this.activatedRoute.snapshot.queryParams.drawerSurface || this.activatedRoute.snapshot.queryParams.surface || null,
      routeGroupDraftMode: this.embedded ? null : this.activatedRoute.snapshot.queryParams.drawerGroupMode || this.activatedRoute.snapshot.queryParams.groupMode || null,
      routeOptionsMode: this.embedded ? null : this.activatedRoute.snapshot.queryParams.drawerOptionsMode || this.activatedRoute.snapshot.queryParams.optionsMode || null
    });
  }

  private initializeExpandedGroups() {
    this.expandedGroups = {};
    const groups = this.editor?.groups || [];
    const focusGroupId = this.getContextFocusGroupId();

    if (this.embedded) {
      groups.forEach((grupo) => {
        this.expandedGroups[this.groupKey(grupo)] = false;
      });
      return;
    }

    if (focusGroupId != null) {
      const hasFocusedGroup = groups.some((grupo) => String(grupo.id) === String(focusGroupId));
      if (!hasFocusedGroup) {
        groups.forEach((grupo) => {
          this.expandedGroups[this.groupKey(grupo)] = true;
        });
        return;
      }

      groups.forEach((grupo) => {
        const isFocused = String(grupo.id) === String(focusGroupId);
        this.expandedGroups[this.groupKey(grupo)] = isFocused;
      });
      return;
    }

    groups.forEach((grupo) => {
      this.expandedGroups[this.groupKey(grupo)] = true;
    });
  }

  private initializeGroupDetailDraft() {
    if (!this.isGroupDetailSurface) {
      this.groupDraft = null;
      this.editingGroupId = null;
      this.optionBrowserContextKey = '';
      return;
    }

    const targetGroup = this.focusedGroup;
    const groupDraftMode = this.getContextGroupDraftMode();
    const requestedOptionMode = this.getContextOptionMode();
    const nextContextKey = targetGroup ? `group:${targetGroup.id}` : groupDraftMode === 'create' ? 'create' : '';

    if (nextContextKey !== this.optionBrowserContextKey) {
      this.resetOptionBrowserState();
      this.optionBrowserContextKey = nextContextKey;
    }

    this.loadPersistedOptionState(nextContextKey, requestedOptionMode);

    if (targetGroup) {
      this.groupDraft = this.cloneGroup(targetGroup);
      this.editingGroupId = targetGroup.id;
      this.groupPanelTitle = 'Editar adicional';
      return;
    }

    if (groupDraftMode === 'create') {
      this.groupDraft = this.buildEmptyGroupDraft();
      this.editingGroupId = null;
      this.groupPanelTitle = 'Novo adicional';
      return;
    }

    this.groupDraft = null;
    this.editingGroupId = null;
  }

  private buildEmptyGroupDraft(): ChoiceGroupVM {
    return {
      id: null,
      name: '',
      type: 'single',
      required: false,
      min: 0,
      max: 1,
      chargeType: 'soma',
      shared: false,
      sharedCount: 0,
      order: this.editor?.groups.length || 0,
      kind: 'adicional',
      description: 'Escolha 1 • 0 opções',
      options: []
    };
  }

  private syncBasicInfoToRaw() {
    if (!this.editor) return;

    this.editor.raw.nome = this.editor.name;
    this.editor.raw.descricao = this.editor.description;
    this.editor.raw.categoria = this.categorias.find((categoria) => categoria.id === this.editor?.categoryId) || null;
    this.facade.apliquePrecoEfetivo(this.editor.raw, this.editor.basePrice);

    this.editor.raw.codigoPdv = this.editor.codigoPdv;
    this.editor.raw.tipoDeVenda = this.editor.tipoDeVenda;
    this.editor.raw.incremento = this.editor.incremento;
    this.editor.raw.qtdeMinima = this.editor.qtdeMinima;
    this.editor.raw.qtdMaxima = this.editor.qtdMaxima;
    this.editor.raw.pesoMinimo = this.editor.pesoMinimo;
    this.editor.raw.pesoMaximo = this.editor.pesoMaximo;
    this.editor.raw.unidadeMedida = this.editor.unidadeMedida;
    this.editor.raw.valorInicial = this.editor.valorInicial;
    this.editor.raw.ehBrinde = this.editor.ehBrinde;
    this.editor.raw.naoAceitaCupom = this.editor.naoAceitaCupom;
    this.editor.raw.sincronizarModelos = this.editor.sincronizarModelos;
  }

  private async ensureProductPersisted(errorMessage: string): Promise<boolean> {
    if (!this.editor) return false;

    if (this.editor.id || this.editor.raw?.id) {
      await this.syncResolvedProductState(false);
      return true;
    }

    this.syncBasicInfoToRaw();

    try {
      await this.markSaving();
      await this.facade.salveProduto(this.editor.raw);
      await this.syncResolvedProductState(true);
      this.isNewProduct = false;
      return true;
    } catch (error: any) {
      this.handleSaveError(error, errorMessage);
      return false;
    }
  }

  private async syncResolvedProductState(replaceUrl: boolean): Promise<void> {
    if (!this.editor?.raw?.id) return;

    const resolvedId = Number(this.editor.raw.id);
    const shouldEmitResolved = this.editor.id == null || Number(this.editor.id) !== resolvedId;
    this.editor.id = resolvedId;

    if (shouldEmitResolved) {
      this.productResolved.emit(resolvedId);
    }

    if (!this.embedded && replaceUrl) {
      await this.navigateToAdminEditor(resolvedId, this.getResolvedEditorQueryParams(), { replaceUrl: true });
    }
  }

  private getResolvedEditorQueryParams(): any {
    const queryParams = { ...this.activatedRoute.snapshot.queryParams };
    delete queryParams['tipo'];
    return queryParams;
  }

  private requestSurfaceChange(
    surfaceMode: ProductEditorSurfaceV2,
    focusGroupId: number | string | null = null,
    groupDraftMode: ProductEditorGroupDraftModeV2 | null = null,
    startWithLibrary = false,
    optionMode: ProductEditorOptionModeV2 | null = null
  ) {
    this.groupDraft = null;
    this.editingGroupId = null;

    if (this.embedded) {
      this.surfaceChangeRequested.emit({
        surfaceMode,
        focusGroupId,
        groupDraftMode,
        startWithLibrary,
        optionMode
      });
      return;
    }

    void this.router.navigate([], {
      relativeTo: this.activatedRoute,
      queryParams: {
        drawerSurface: surfaceMode !== 'overview' ? surfaceMode : null,
        surface: surfaceMode !== 'overview' ? surfaceMode : null,
        drawerGroup: focusGroupId != null ? focusGroupId : null,
        grupo: focusGroupId != null ? focusGroupId : null,
        drawerGroupMode: groupDraftMode || null,
        groupMode: groupDraftMode || null,
        drawerLibrary: startWithLibrary ? 1 : null,
        library: startWithLibrary ? 1 : null,
        drawerOptionsMode: optionMode || null,
        optionsMode: optionMode || null
      },
      queryParamsHandling: 'merge',
      replaceUrl: true
    });
  }

  private async promoteToDedicatedEditor(grupo?: ChoiceGroupVM, forceOverview = false) {
    if (!this.editor) return;

    const queryParams: any = {};

    if (grupo?.id != null) {
      queryParams.drawerGroup = grupo.id;
      queryParams.grupo = grupo.id;
    }

    if (forceOverview) {
      queryParams.drawerSurface = null;
      queryParams.surface = null;
      queryParams.drawerGroup = null;
      queryParams.grupo = null;
      queryParams.drawerGroupMode = null;
      queryParams.groupMode = null;
      queryParams.drawerLibrary = null;
      queryParams.library = null;
      queryParams.drawerOptionsMode = null;
      queryParams.optionsMode = null;
    } else if (this.activeSurfaceMode !== 'overview') {
      queryParams.drawerSurface = this.activeSurfaceMode;
      queryParams.surface = this.activeSurfaceMode;
    }

    if (!forceOverview && this.getContextGroupDraftMode()) {
      queryParams.drawerGroupMode = this.getContextGroupDraftMode();
      queryParams.groupMode = this.getContextGroupDraftMode();
    }

    if (!forceOverview && this.libraryOpen) {
      queryParams.drawerLibrary = 1;
      queryParams.library = 1;
    }

    if (!forceOverview && this.optionMode) {
      queryParams.drawerOptionsMode = this.optionMode;
      queryParams.optionsMode = this.optionMode;
    }

    if (this.editor.type && !this.editor.id) {
      queryParams.tipo = this.editor.type;
    }

    if (this.editor.id) {
      await this.navigateToAdminEditor(this.editor.id, queryParams);
      return;
    }

    await this.navigateToAdminNewProduct(queryParams);
  }

  private async navigateToAdminCatalog() {
    return this.navigateWithFeedback(
      ['/admin/produtos-v2'],
      {},
      'Não foi possível voltar para o catálogo de produtos.'
    );
  }

  private async navigateToAdminEditor(productId: number, queryParams: any = {}, extras: any = {}) {
    return this.navigateWithFeedback(
      [`/admin/produtos-v2/${productId}`],
      {
        ...extras,
        queryParams
      },
      'Não foi possível abrir o editor do produto.'
    );
  }

  private async navigateToAdminNewProduct(queryParams: any = {}, extras: any = {}) {
    return this.navigateWithFeedback(
      ['/admin/produtos-v2/novo'],
      {
        ...extras,
        queryParams
      },
      'Não foi possível abrir o cadastro do produto.'
    );
  }

  private async navigateWithFeedback(commands: any[], extras: any, errorMessage: string): Promise<boolean> {
    try {
      const navigated = await this.router.navigate(commands, extras);
      if (!navigated) {
        this.notificationService.showError(errorMessage);
      }
      return navigated;
    } catch (error: any) {
      this.notificationService.showError(error?.message || errorMessage);
      return false;
    }
  }

  private resetOptionBrowserState() {
    if (this.optionMode === 'batch-price') {
      this.clearBatchSelection();
    }
    this.optionMode = 'review';
    this.optionSearch = '';
    this.optionFilter = 'all';
    this.optionSort = 'name-asc';
    this.batchPriceInput = '';
  }

  private loadPersistedOptionState(contextKey: string, requestedMode: ProductEditorOptionModeV2 | null) {
    this.optionMode = this.groupOptionModes[contextKey] || requestedMode || 'review';
    this.optionSearch = this.groupOptionSearchState[contextKey] || '';
    this.optionFilter = this.groupOptionFilterState[contextKey] || 'all';
    this.optionSort = this.groupOptionSortState[contextKey] || 'name-asc';
    this.batchPriceInput = '';
    this.clearBatchSelection();
  }

  private persistOptionState() {
    if (!this.optionBrowserContextKey) return;

    this.groupOptionModes[this.optionBrowserContextKey] = this.optionMode;
    this.groupOptionSearchState[this.optionBrowserContextKey] = this.optionSearch;
    this.groupOptionFilterState[this.optionBrowserContextKey] = this.optionFilter;
    this.groupOptionSortState[this.optionBrowserContextKey] = this.optionSort;
  }

  private getOptionRuntimeKey(option: ChoiceOptionVM): string {
    const existing = this.optionRuntimeKeys.get(option);
    if (existing) return existing;

    const key = option.id != null ? `option:${option.id}` : `draft:${++this.optionRuntimeKeySequence}`;
    this.optionRuntimeKeys.set(option, key);
    return key;
  }

  private applyBatchPrice(price: number) {
    const group = this.focusedGroup;
    if (!group || !this.batchSelectedCount) return;
    if (!this.podeEditarPrecoOpcoes) {
      this.notifySharedCatalogBlocked('O preço em massa está bloqueado neste catálogo compartilhado.');
      return;
    }

    (group.options || [])
      .filter((option) => this.isBatchOptionSelected(option))
      .forEach((option) => {
        option.price = price;
        this.syncOptionToRaw(group, option);
      });

    this.scheduleGroupSave(group);
    this.notificationService.showSuccess('Preço aplicado em lote.');
  }

  private parseOptionMoney(value: string): number {
    const normalized = String(value || '0').replace(/[^\d,.-]/g, '').replace(/\./g, '').replace(',', '.');
    const amount = Number(normalized);
    return Number.isFinite(amount) ? amount : 0;
  }

  private formatMoneyValue(value: number): string {
    return Number(value || 0).toFixed(2).replace('.', ',');
  }

  private notifySharedCatalogBlocked(message = 'Catálogo compartilhado: edição bloqueada nesta área do editor.'): void {
    this.notificationService.showError(message);
  }
}
